import React, { Component } from 'react'
import g from 'glamorous'

class TeamInCard extends Component { 
    render () {
        const { pic, name, minTxt, maxTxt, valueTxt, barPercent } = this.props
        return (<g.Li>
                    <g.Div 
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        className="content-info">
                        <g.Img 
                            height="100%"
                            src={require(pic)} alt={name} title={name} />
                        <g.Div className="card-metadata">
                            <g.Div
                                className={"title" + (name == "Bebidas alcohólicas prohibidas" ? " reduce-title-px" : "") }
                                textTransform="uppercase">{name}</g.Div>
                            <g.Div className="bar">
                                <g.Div className="info-general">{valueTxt}</g.Div>
                            </g.Div>
                        </g.Div>
                    </g.Div>
                </g.Li>)
    }
}

export default TeamInCard



// WEBPACK FOOTER //
// ./src/components/calendar/team-in-card-fragm.js